import React from "react";
import Select from "react-select";
import cx from "classnames";
import s from "./select.scss";
import { t } from "i18next";

export default class S extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value ? this.findActiveOption(props.value, props.options) : null,
    };
  }

  reset = () => {
    this.setState({ value: null }, () => {
      if (this.props.onChange) {
        this.props.onChange({ [this.props.name]: undefined });
      }
      if (this.selectElement) {
        this.selectElement.clearValue();
      }
    });
  };

  findActiveOption = (value, options) => {
    return options?.filter((o) => o.value === value)[0] || null;
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ value: this.findActiveOption(nextProps.value, nextProps.options) });
  }

  updateValue = (val) => {
    this.setState({ value: val });
    if (this.props.onChange) {
      this.props.onChange({ [this.props.name]: val ? val.value : undefined });
    }
  };

  render() {
    const {
      className,
      options,
      name,
      label,
      errors,
      placeholder,
      hint,
      isLoading,
      required,
      noRequired,
      inline = false,
      disabled,
      helpTooltip,
      noOptionsMessage,
      optionComponent,
      isActive,
    } = this.props;

    let ovverrides = {};

    if (optionComponent) ovverrides.Option = optionComponent;

    return (
      <div
        className={cx(className, s.selectContainer, {
          [s.withErrors]: errors,
          [s.labelinrow]: inline,
          [s.labelHint]: hint,
          [s.required]: required && !noRequired,
          [s.disabled]: disabled,
        })}
      >
        {(label || hint) && (
          <div className={s.wrapLabel}>
            <label className={s.label}>{label || name.replace("_", " ")}</label>
            {hint && <div className={s.hint}>{hint}</div>}
            {helpTooltip && <div className={s.helpTooltip}>{helpTooltip}</div>}
          </div>
        )}

        <Select
          {...this.props}
          components={ovverrides}
          className={cx(s.select, "wrapSelect", {
            [s.isActive]: isActive,
          })}
          classNamePrefix="select"
          isLoading={isLoading}
          ref={(el) => (this.selectElement = el)}
          value={this.state.value || this.props.initialValue}
          placeholder={placeholder}
          openOnFocus
          isDisabled={this.props.disabled}
          options={options}
          onChange={this.updateValue}
          noOptionsMessage={() => noOptionsMessage || t("input.placeholder.domain.notFound")}
        />
        {errors && <div className={s.errorMsg}>{errors}</div>}
      </div>
    );
  }
}
